import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewChild
} from "@angular/core";
import {GroupedOutletCustomData} from "../grouped-outlet-custom.data";
import {GroupedOutletCustomSearchModel} from "../grouped-outlet-custom-search.model";
import {ItemType, LocalisationOutletSelectionComponent} from "./localisation-outlet-selection.component";
import {Subscription} from "rxjs";
import {FUIDeprecatedAutocompleteControlComponent} from "@fedeltapointofsale/ui";


export class SearchItemData {
    constructor(public id: any, public itemType: ItemType, public name: string) {
    }
}

/**
 * Provides auto complete selection capabilities to a LocalisationOutletSelectionComponent. The
 * LocalisationOutletSelectionComponent must be provided as an input to this component. The
 * LocalisationOutletSelectionComponent contains all the state of selected outlets.
 */
@Component({
    selector: "wbo-localisation-outlet-selection-autocomplete",
    templateUrl: "./localisation-outlet-selection-autocomplete.component.html",
    styleUrls: ["./localisation-outlet-selection-autocomplete.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LocalisationOutletSelectionAutocompleteComponent implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild("searchControl") searchControl: FUIDeprecatedAutocompleteControlComponent;

    filteredSearchData: SearchItemData[] = [];
    searchData: SearchItemData[] = [];

    ItemType = ItemType;

    @Input() panelComponent: LocalisationOutletSelectionComponent;

    @Input() readonly: boolean;

    private searchSubscription: Subscription;
    private filterSubscription: Subscription;


    constructor(public searchModel: GroupedOutletCustomSearchModel, private changeDetectorRef: ChangeDetectorRef) {
    }


    ngOnInit(): void {
        this.buildSearchData();
    }

    ngOnDestroy(): void {
        if (this.searchSubscription) {
            this.searchSubscription.unsubscribe();
        }
        if (this.filterSubscription) {
            this.filterSubscription.unsubscribe();
        }
    }

    ngAfterViewInit(): void {
        this.filterSubscription = this.searchControl.filtered.subscribe(value => {
            this.filteredSearchData = this.searchData.filter(item => item.name.toUpperCase().indexOf(value.toUpperCase()) > -1);
            this.changeDetectorRef.markForCheck();
        });
    }



    buildSearchData(): void {
        const data = [];
        let currentGroup: string;
        this.searchSubscription = this.searchModel.$data.subscribe((groupedOutletCustomData: GroupedOutletCustomData[]) => {
            groupedOutletCustomData.forEach((item: GroupedOutletCustomData) => {
                if (item.type === GroupedOutletCustomData.TYPE_OUTLET) {
                    data.push(new SearchItemData(item.id, ItemType.OUTLET, item.name));
                    if (currentGroup !== item.group) {
                        data.push(new SearchItemData(item.group, ItemType.OUTLET_GROUP, item.group));
                        currentGroup = item.group;
                    }
                } else {
                    data.push(new SearchItemData(item.id, ItemType.CUSTOM_OBJECT, item.name));
                }
            });
            this.searchData = data.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0);
            this.changeDetectorRef.markForCheck();
        })
    }

    /**
     *
     * @param item
     * @returns {boolean}
     */
    isSearchItemSelected(item: SearchItemData): boolean {
        return this.panelComponent.isSelected(item.id, item.itemType);
    }

    /**
     *
     * @param item
     */
    toggleSelection(item: SearchItemData): void {
        this.panelComponent.toggleSelection(item.id, item.itemType);
    }


}
